import { getFAIconClass } from "@juiceforward/narrative-schema/icon-utils";

interface IconProps {
  /** Narrative icon string, e.g. "fass chart-line", "chart-line", "fa-chart-line". */
  icon: string | undefined | null;
  /** Extra classes (Tailwind sizing/color, animate-spin, etc.). */
  className?: string;
  /** Native tooltip text. When set, the icon is exposed to assistive tech. */
  title?: string;
}

/**
 * Renders a Font Awesome icon as `<i class="fausb fa-{name} …">`, matching the
 * kit's Web Fonts + CSS delivery. Returns null for empty/unknown input, which
 * renders nothing — the same behavior as the previous SVG component when an
 * icon didn't resolve.
 */
export function Icon({ icon, className, title }: IconProps) {
  const base = getFAIconClass(icon);
  if (!base) return null;
  const cls = className ? `${base} ${className}` : base;
  // A titled icon carries meaning, so expose it to assistive tech with an
  // explicit accessible name; untitled icons stay decorative (aria-hidden).
  return title ? (
    <i className={cls} title={title} role="img" aria-label={title} />
  ) : (
    <i className={cls} aria-hidden={true} />
  );
}
